import { reachAndResolve } from '@framework/validation';
import { FieldValues } from 'react-hook-form';
import { IFormAugmentedContext } from '../form/augmented/FormAugmentedContext';

export function getAugmentedSchema(
  augmented: IFormAugmentedContext,
  values: FieldValues,
  name: string,
) {
  try {
    return reachAndResolve(
      augmented.schema,
      name,
      values,
      augmented.validationContext,
    );
  } catch (e) {
    return null;
  }
}
